var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 49,
    viewBox: "0 0 60 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.6367 6.33317C57.455 7.32484 55.1033 7.9765 52.6667 8.28817C55.16 6.7865 57.0867 4.4065 57.9933 1.54484C55.6417 2.9615 53.035 3.95317 50.2867 4.51984C48.0483 2.08317 44.9033 0.666504 41.3333 0.666504C34.675 0.666504 29.235 6.1065 29.235 12.8215C29.235 13.7848 29.3483 14.7198 29.5467 15.5982C19.46 15.0882 10.4783 10.2432 4.50001 2.90484C3.45168 4.68984 2.85668 6.7865 2.85668 8.9965C2.85668 13.2182 4.98168 16.9582 8.26834 19.0832C6.25668 19.0832 4.38668 18.5165 2.74334 17.6665V17.7515C2.74334 23.6448 6.93668 28.5748 12.49 29.6798C10.7074 30.1698 8.83511 30.2377 7.02168 29.8782C7.79123 32.2935 9.29836 34.407 11.3312 35.9215C13.3641 37.436 15.8204 38.2753 18.355 38.3215C14.0587 41.7229 8.73304 43.5615 3.25334 43.5348C2.29001 43.5348 1.32668 43.4782 0.363342 43.3648C5.74668 46.8215 12.15 48.8332 19.0067 48.8332C41.3333 48.8332 53.6017 30.3032 53.6017 14.2382C53.6017 13.6998 53.6017 13.1898 53.5733 12.6515C55.9533 10.9515 57.9933 8.79817 59.6367 6.33317Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.0ae341fb60a482eeb17d10a06895e9c2.svg";
export { ForwardRef as ReactComponent };